import { inject, Injectable } from '@angular/core';
import { ConfigurableBundleTemplateModel } from '@libs/shop/models';
import { ConnectorService } from '@libs/shared/services';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfigurableBundleRepositoryService {
  private readonly connector: ConnectorService = inject(ConnectorService);

  public getById(templateId: string): Observable<ConfigurableBundleTemplateModel> {
    return this.connector.connect('shop', 'configurableBundleTemplateGetById', {
      pathParams: { templateId },
    });
  }
}
